import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Category from './Category';
import { getCurrencyObject } from '../hooks/currency';
import { Button } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
   // paddingBottom: "20vh"
  },

  gridRow:{
    justifyContent: 'center',
    padding: theme.spacing(1),
  },
  gridFooter:{
    display:'flex',
    justifyContent: 'center',
    padding: theme.spacing(1),
  },

  contentTitle:{
    //fontFamily: "'Baloo 2', cursive",
    width: '100%',
    //textTransform: 'uppercase',
    textAlign:'center', 
  }

}));

export default function GridMenu(props) {
  const classes = useStyles();

  const {currency,onClickViewMore,labelViewMore,isTakingOrder,strings}  = props; 
  const [currencyFormat, setCounter] = React.useState({
    ...currency,
  } );
  
  if(!props.current || !props.current.content){
        return "";  
     }

  const categories = props.current.content.categories; 
  const {orderList, setOrderList, onOrderListChange,locationType,onOrderAddItemAdditions} = props;
  const {title,showCurrency} = props.current.content
    

    
  

  

    const handlerOnclicViewMore = ()=>{
        if(onClickViewMore){
          onClickViewMore()
        }
    }
 
    return (
      <div className={classes.root}>
        <Grid container spacing={1} className={classes.gridRow}>
           
           { title && title!="" && 
            <Typography mx={2} mt={3} mb={1} variant="h4" color='textSecondary' className={classes.contentTitle} >
             {title} 
            </Typography>
           }

          {categories.map((category,index)=>(
            <Category 
            key={category.uid} 
            currency={currencyFormat}
            showCurrency={showCurrency}
            category={category}
            onOrderListChange = {onOrderListChange}
            orderList={orderList}
            setOrderList={setOrderList}
            isTakingOrder={isTakingOrder}
            strings={strings}
            locationType={locationType}
            onOrderAddItemAdditions={onOrderAddItemAdditions}
            />
          ))}       
        </Grid>

        {onClickViewMore && 
        <div  className={classes.gridFooter}>
            <Button
            
            variant="contained" 
            color="primary"
            size='large' 
            onClick = {handlerOnclicViewMore}               
            >                 
            {labelViewMore}
            </Button>
        </div> 
        }  
       

      </div>
    );
}